/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: voJV0X1zqcH0
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicButtonPage.module.css"; // plasmic-import: voJV0X1zqcH0/css

createPlasmicElementProxy;

export const PlasmicButtonPage__VariantProps = new Array(
  "textColor",
  "isSelected"
);

export const PlasmicButtonPage__ArgProps = new Array(
  "onClick",
  "disabled",
  "name",
  "content"
);

const $$ = {};

function PlasmicButtonPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false,
          content: "link button"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.textColor
      },
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isSelected
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"wrappAll"}
      data-plasmic-override={overrides.wrappAll}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.wrappAll,
        {
          [sty.wrappAllisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.wrappAlltextColor_brand]: hasVariant(
            $state,
            "textColor",
            "brand"
          ),
          [sty.wrappAlltextColor_primaryDark]: hasVariant(
            $state,
            "textColor",
            "primaryDark"
          ),
          [sty.wrappAlltextColor_secondary]: hasVariant(
            $state,
            "textColor",
            "secondary"
          )
        }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(
          projectcss.all,
          projectcss.a,
          projectcss.__wab_text,
          sty.link,
          {
            [sty.linkisSelected]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
            [sty.linktextColor_brand]: hasVariant($state, "textColor", "brand"),
            [sty.linktextColor_primaryDark]: hasVariant(
              $state,
              "textColor",
              "primaryDark"
            ),
            [sty.linktextColor_primaryGrey]: hasVariant(
              $state,
              "textColor",
              "primaryGrey"
            ),
            [sty.linktextColor_primaryLight]: hasVariant(
              $state,
              "textColor",
              "primaryLight"
            ),
            [sty.linktextColor_secondary]: hasVariant(
              $state,
              "textColor",
              "secondary"
            ),
            [sty.linktextColor_tertiary]: hasVariant(
              $state,
              "textColor",
              "tertiary"
            )
          }
        )}
        disabled={(() => {
          try {
            return $props.disabled;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        name={(() => {
          try {
            return $props.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        platform={"react"}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.content;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "continue";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </PlasmicLink__>
    </div>
  );
}

const PlasmicDescendants = {
  wrappAll: ["wrappAll", "link"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonPage__ArgProps,
          internalVariantPropNames: PlasmicButtonPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrappAll") {
    func.displayName = "PlasmicButtonPage";
  } else {
    func.displayName = `PlasmicButtonPage.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonPage = Object.assign(
  // Top-level PlasmicButtonPage renders the root element
  makeNodeComponent("wrappAll"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicButtonPage
    internalVariantProps: PlasmicButtonPage__VariantProps,
    internalArgProps: PlasmicButtonPage__ArgProps
  }
);

export default PlasmicButtonPage;
/* prettier-ignore-end */
